import { render, staticRenderFns } from "./businessProcess.vue?vue&type=template&id=9089f3d8&scoped=true"
import script from "./businessProcess.vue?vue&type=script&lang=js"
export * from "./businessProcess.vue?vue&type=script&lang=js"
import style0 from "./businessProcess.vue?vue&type=style&index=0&id=9089f3d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9089f3d8",
  null
  
)

export default component.exports